import { Component } from 'react'
import type { ErrorInfo, PropsWithChildren, ReactNode } from 'react'
import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'

interface AppErrorBoundaryState {
  hasError: boolean
}

export class AppErrorBoundary extends Component<PropsWithChildren, AppErrorBoundaryState> {
  public override state: AppErrorBoundaryState = { hasError: false }

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true }
  }

  public override componentDidCatch(error: unknown, errorInfo: ErrorInfo): void {
    reportUnexpectedError(error, {
      boundary: 'root',
      componentStack: errorInfo.componentStack ?? undefined,
    })
  }

  public override render(): ReactNode {
    if (this.state.hasError) {
      return (
        <main className="app-fallback" aria-labelledby="app-error-title">
          <div className="app-fallback__panel">
            <p className="app-fallback__eyebrow">Centre des opérations</p>
            <h1 id="app-error-title">L’application n’a pas pu démarrer.</h1>
            <p>Actualisez la page. Si le problème persiste, communiquez avec le soutien RECA.</p>
            <button
              type="button"
              onClick={() => {
                window.location.reload()
              }}
            >
              Actualiser
            </button>
          </div>
        </main>
      )
    }

    return this.props.children
  }
}
